app.filter('monthName', [function () {
    return function (monthNumber) { //1 = January
        const monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'];
        return monthNames[monthNumber - 1];
    }
}]);